var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"position":"absolute","top":"1.5rem","width":"100%","bottom":"0.8rem"}},[_c('iframe',{staticStyle:{"width":"100%","height":"99%"},attrs:{"src":_vm.url,"frameborder":"no","border":"0","marginWidth":"0","marginHeight":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }